// source: src/common/integration/searcher/searcher.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var src_common_integration_object_fieldsetting_fieldsetting_pb = require('../../../../src/common/integration/object/fieldsetting/fieldsetting_pb.js');
goog.object.extend(proto, src_common_integration_object_fieldsetting_fieldsetting_pb);
var src_common_filter_filter_pb = require('../../../../src/common/filter/filter_pb.js');
goog.object.extend(proto, src_common_filter_filter_pb);
goog.exportSymbol('proto.loupe.common.integration.searcher.IntegrationSearchExpression', null, global);
goog.exportSymbol('proto.loupe.common.integration.searcher.IntegrationSearcher', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.integration.searcher.IntegrationSearcher = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.integration.searcher.IntegrationSearcher.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.integration.searcher.IntegrationSearcher, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.integration.searcher.IntegrationSearcher.displayName = 'proto.loupe.common.integration.searcher.IntegrationSearcher';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.integration.searcher.IntegrationSearchExpression.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.integration.searcher.IntegrationSearchExpression, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.integration.searcher.IntegrationSearchExpression.displayName = 'proto.loupe.common.integration.searcher.IntegrationSearchExpression';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.integration.searcher.IntegrationSearcher.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.integration.searcher.IntegrationSearcher.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.integration.searcher.IntegrationSearcher.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.integration.searcher.IntegrationSearcher} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.integration.searcher.IntegrationSearcher.toObject = function(includeInstance, msg) {
  var f, obj = {
    objectKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    valuesList: jspb.Message.toObjectList(msg.getValuesList(),
    proto.loupe.common.integration.searcher.IntegrationSearchExpression.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearcher}
 */
proto.loupe.common.integration.searcher.IntegrationSearcher.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.integration.searcher.IntegrationSearcher;
  return proto.loupe.common.integration.searcher.IntegrationSearcher.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.integration.searcher.IntegrationSearcher} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearcher}
 */
proto.loupe.common.integration.searcher.IntegrationSearcher.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectKey(value);
      break;
    case 2:
      var value = new proto.loupe.common.integration.searcher.IntegrationSearchExpression;
      reader.readMessage(value,proto.loupe.common.integration.searcher.IntegrationSearchExpression.deserializeBinaryFromReader);
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.integration.searcher.IntegrationSearcher.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.integration.searcher.IntegrationSearcher.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.integration.searcher.IntegrationSearcher} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.integration.searcher.IntegrationSearcher.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObjectKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.loupe.common.integration.searcher.IntegrationSearchExpression.serializeBinaryToWriter
    );
  }
};


/**
 * optional string object_key = 1;
 * @return {string}
 */
proto.loupe.common.integration.searcher.IntegrationSearcher.prototype.getObjectKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearcher} returns this
 */
proto.loupe.common.integration.searcher.IntegrationSearcher.prototype.setObjectKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated IntegrationSearchExpression values = 2;
 * @return {!Array<!proto.loupe.common.integration.searcher.IntegrationSearchExpression>}
 */
proto.loupe.common.integration.searcher.IntegrationSearcher.prototype.getValuesList = function() {
  return /** @type{!Array<!proto.loupe.common.integration.searcher.IntegrationSearchExpression>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.loupe.common.integration.searcher.IntegrationSearchExpression, 2));
};


/**
 * @param {!Array<!proto.loupe.common.integration.searcher.IntegrationSearchExpression>} value
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearcher} returns this
*/
proto.loupe.common.integration.searcher.IntegrationSearcher.prototype.setValuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.loupe.common.integration.searcher.IntegrationSearchExpression=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearchExpression}
 */
proto.loupe.common.integration.searcher.IntegrationSearcher.prototype.addValues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.loupe.common.integration.searcher.IntegrationSearchExpression, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearcher} returns this
 */
proto.loupe.common.integration.searcher.IntegrationSearcher.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.integration.searcher.IntegrationSearchExpression.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.integration.searcher.IntegrationSearchExpression} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.toObject = function(includeInstance, msg) {
  var f, obj = {
    valuesList: msg.getValuesList_asB64(),
    fieldName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fieldType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    fieldIsPicklist: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    operation: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearchExpression}
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.integration.searcher.IntegrationSearchExpression;
  return proto.loupe.common.integration.searcher.IntegrationSearchExpression.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.integration.searcher.IntegrationSearchExpression} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearchExpression}
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addValues(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldName(value);
      break;
    case 3:
      var value = /** @type {!proto.loupe.common.integration.object.fieldsetting.ObjectType} */ (reader.readEnum());
      msg.setFieldType(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFieldIsPicklist(value);
      break;
    case 5:
      var value = /** @type {!proto.loupe.common.filter.FilterOperation} */ (reader.readEnum());
      msg.setOperation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.integration.searcher.IntegrationSearchExpression.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.integration.searcher.IntegrationSearchExpression} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValuesList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
  f = message.getFieldName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFieldType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getFieldIsPicklist();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getOperation();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * repeated bytes values = 1;
 * @return {!(Array<!Uint8Array>|Array<string>)}
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.getValuesList = function() {
  return /** @type {!(Array<!Uint8Array>|Array<string>)} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes values = 1;
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<string>}
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.getValuesList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getValuesList()));
};


/**
 * repeated bytes values = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValuesList()`
 * @return {!Array<!Uint8Array>}
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.getValuesList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getValuesList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearchExpression} returns this
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearchExpression} returns this
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearchExpression} returns this
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * optional string field_name = 2;
 * @return {string}
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.getFieldName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearchExpression} returns this
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.setFieldName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional loupe.common.integration.object.fieldsetting.ObjectType field_type = 3;
 * @return {!proto.loupe.common.integration.object.fieldsetting.ObjectType}
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.getFieldType = function() {
  return /** @type {!proto.loupe.common.integration.object.fieldsetting.ObjectType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.loupe.common.integration.object.fieldsetting.ObjectType} value
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearchExpression} returns this
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.setFieldType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool field_is_picklist = 4;
 * @return {boolean}
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.getFieldIsPicklist = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearchExpression} returns this
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.setFieldIsPicklist = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional loupe.common.filter.FilterOperation operation = 5;
 * @return {!proto.loupe.common.filter.FilterOperation}
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.getOperation = function() {
  return /** @type {!proto.loupe.common.filter.FilterOperation} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.loupe.common.filter.FilterOperation} value
 * @return {!proto.loupe.common.integration.searcher.IntegrationSearchExpression} returns this
 */
proto.loupe.common.integration.searcher.IntegrationSearchExpression.prototype.setOperation = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


goog.object.extend(exports, proto.loupe.common.integration.searcher);
